function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";
import { useIsCreateOrEdit } from "../../hooks/use-is-create-or-edit.js";
import { useGetCanActivate } from "../../hooks/use-get-can-activate.js";
// TODO: review how to type this component
export const RbacInput = (_ref) => {
  let {
    component: Input,
    resource,
    source
  } = _ref,
      props = _objectWithoutProperties(_ref, ["component", "resource", "source"]);

  const {
    loaded,
    canActivate
  } = useGetCanActivate();
  const {
    action
  } = useIsCreateOrEdit();

  if (!loaded && !canActivate) {
    return null;
  }

  if (!source) {
    return /*#__PURE__*/React.createElement(Input, _objectSpread(_objectSpread({}, props), {}, {
      resource,
      source
    }));
  }

  if (canActivate(resource, action, source)) {
    return /*#__PURE__*/React.createElement(Input, _objectSpread(_objectSpread({}, props), {}, {
      resource,
      source
    }));
  }

  return null;
};
RbacInput.displayName = "RbacInput";